import { createContext } from 'react';
import { CameraBrand } from './types';
export const CameraContext = createContext<CameraBrand[]>([]);
